// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader__header--1CQ","info":"MobileHeader__info--3VE","controls":"MobileHeader__controls--31s","accountIcon":"MobileHeader__accountIcon--yxa"};